import { inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, forkJoin } from 'rxjs';
import { LookupItemModel, LookupStore } from '@/state/lookup-store';
import { environment } from 'src/environments/environment';
import { CanActivateFn } from '@angular/router';

export async function loadLookupData() {
    const http = inject(HttpClient);
    const lookupStore = inject(LookupStore);

    // Check if already loaded to avoid redundant calls
    if (lookupStore.states().length > 0) {
        return true;
    }

    try {
        const results = await firstValueFrom(
            forkJoin({
                states: http.get<LookupItemModel[]>(`${environment.apiBase}/api/lookup/state`),
                waitingStates: http.get<LookupItemModel[]>(`${environment.apiBase}/api/lookup/waiting-state`),
                salutations: http.get<LookupItemModel[]>(`${environment.apiBase}/api/lookup/salutation`),
                correspondence: http.get<LookupItemModel[]>(`${environment.apiBase}/api/lookup/correspondence`),
                documentTypes: http.get<LookupItemModel[]>(`${environment.apiBase}/api/lookup/document-type`),
                dueTypes: http.get<LookupItemModel[]>(`${environment.apiBase}/api/lookup/due-type`),
                relationTypes: http.get<LookupItemModel[]>(`${environment.apiBase}/api/lookup/relation-type`),
                years: http.get<LookupItemModel[]>(`${environment.apiBase}/api/lookup/year`),
                residencePermits: http.get<LookupItemModel[]>(`${environment.apiBase}/api/lookup/residence-permit`),
                memberStateTypes: http.get<LookupItemModel[]>(`${environment.apiBase}/api/lookup/user-member-state-type`),
                systemMemberStateTypes: http.get<LookupItemModel[]>(`${environment.apiBase}/api/lookup/system-member-state-type`),
                allMemberStateTypes: http.get<LookupItemModel[]>(`${environment.apiBase}/api/lookup/all-member-state-type`)
            })
        );

        lookupStore.setStates(results.states);
        lookupStore.setWaitingStates(results.waitingStates);
        lookupStore.setSalutations(results.salutations);
        lookupStore.setCorrespondence(results.correspondence);
        lookupStore.setDocumentTypes(results.documentTypes);
        lookupStore.setDueTypes(results.dueTypes);
        lookupStore.setRelationTypes(results.relationTypes);
        lookupStore.setYears(results.years);
        lookupStore.setResidencePermits(results.residencePermits);
        lookupStore.setMemberStateTypes(results.memberStateTypes);
        lookupStore.setSystemMemberStateTypes(results.systemMemberStateTypes);
        lookupStore.setAllMemberStateTypes(results.allMemberStateTypes);

        console.info('Lookup data loaded');
        return true;
    } catch (error) {
        alert('Failed to load lookup data');
        console.error('Failed to load lookup data:', error);
        return false;
    }
}

export const lookupGuard: CanActivateFn = async () => {
    return await loadLookupData();
};
